"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * @author: yangqianjun
 * @file: axios封装
 * @Date: 2019-09-02 15:15:27
 * @LastEditors: yangqianjun
 * @LastEditTime: 2020-01-03 15:33:49
 */
var axios_1 = tslib_1.__importDefault(require("axios"));
var event_1 = require("@tkit/event/lib/event");
var consts_1 = require("./consts");
// @cc: axios 默认配置，可在此处修改
exports.default = axios_1.default.create({
    timeout: 5000,
    withCredentials: true,
    headers: {}
});
exports.emptyFunc = function () { return void 0; };
/** 检测 axios 响应状态 */
function onStatusError(error) {
    var resp = 'response' in error && error.response;
    // IMP: 400客户端错误可能有response.data
    var err = resp
        ? {
            code: resp.status,
            message: resp.data && resp.data.message ? resp.data.message : resp.statusText
        }
        : {
            code: error instanceof axios_1.default.Cancel ? consts_1.AjaxCancelCode : consts_1.AjaxErrorCode,
            message: error.message
        };
    if (err.code === 401 || err.code === 403) {
        event_1.EventCenter.emit('common.user.status', err);
    }
    return err;
}
exports.onStatusError = onStatusError;
var consts_2 = require("./consts");
exports.promiseFactory = consts_2.promiseFactory;
//# sourceMappingURL=axios.js.map